var $c906z$react = require("react");
var $c906z$reactjsxruntime = require("react/jsx-runtime");
var $c906z$styledcomponents = require("styled-components");

"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "Tag", {
    enumerable: true,
    get: function get() {
        return $7539930074911192$exports.Tag;
    }
});
Object.defineProperty(module.exports, "TagSize", {
    enumerable: true,
    get: function get() {
        return $7539930074911192$exports.TagSize;
    }
});
Object.defineProperty(module.exports, "colorStyles", {
    enumerable: true,
    get: function get() {
        return $8b349b372f2398a5$exports.colorStyles;
    }
});
var $7539930074911192$exports = {};
"use strict";
function $7539930074911192$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $7539930074911192$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $7539930074911192$var$_typeof(o);
}
Object.defineProperty($7539930074911192$exports, "__esModule", {
    value: true
});
$7539930074911192$exports.Tag = void 0;
Object.defineProperty($7539930074911192$exports, "TagSize", {
    enumerable: true,
    get: function get() {
        return $8b349b372f2398a5$exports.TagSize;
    }
});

var $7539930074911192$var$_react = $7539930074911192$var$_interopRequireDefault($c906z$react);
var $8b349b372f2398a5$exports = {};
"use strict";
function $8b349b372f2398a5$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $8b349b372f2398a5$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $8b349b372f2398a5$var$_typeof(o);
}
Object.defineProperty($8b349b372f2398a5$exports, "__esModule", {
    value: true
});
$8b349b372f2398a5$exports.colorStyles = $8b349b372f2398a5$exports.TagSize = $8b349b372f2398a5$exports.Tag = $8b349b372f2398a5$exports.CounterWrapper = $8b349b372f2398a5$exports.CloseIcon = void 0;
var $c589462aca75b6d0$exports = {};
"use strict";
Object.defineProperty($c589462aca75b6d0$exports, "__esModule", {
    value: true
});
Object.defineProperty($c589462aca75b6d0$exports, "CloseIcon", {
    enumerable: true,
    get: function get() {
        return $14e7d98ab022b44a$exports.CloseIcon;
    }
});
var $14e7d98ab022b44a$exports = {};
"use strict";
Object.defineProperty($14e7d98ab022b44a$exports, "__esModule", {
    value: true
});
$14e7d98ab022b44a$exports.CloseIcon = void 0;

var $14e7d98ab022b44a$var$_react = $14e7d98ab022b44a$var$_interopRequireDefault($c906z$react);


function $14e7d98ab022b44a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
var $14e7d98ab022b44a$var$CloseIcon = $14e7d98ab022b44a$exports.CloseIcon = function CloseIcon(_ref) {
    var className = _ref.className, _ref$colorCode = _ref.colorCode, colorCode = _ref$colorCode === void 0 ? "p500" : _ref$colorCode, _ref$width = _ref.width, width = _ref$width === void 0 ? 7 : _ref$width, _ref$height = _ref.height, height = _ref$height === void 0 ? 8 : _ref$height, onClick = _ref.onClick, _ref$stroke = _ref.stroke, stroke = _ref$stroke === void 0 ? 0.7 : _ref$stroke;
    var theme = (0, $c906z$styledcomponents.useTheme)();
    var color = theme.color[colorCode];
    return /*#__PURE__*/ (0, $c906z$reactjsxruntime.jsxs)("svg", {
        className: className,
        width: width,
        height: height,
        viewBox: "0 0 7 8",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        onClick: onClick,
        children: [
            /*#__PURE__*/ (0, $c906z$reactjsxruntime.jsx)("path", {
                d: "M0.6875 6.8125L6.3125 1.1875",
                stroke: color,
                strokeWidth: stroke,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $c906z$reactjsxruntime.jsx)("path", {
                d: "M0.6875 1.1875L6.3125 6.8125",
                stroke: color,
                strokeWidth: stroke,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};





var $8b349b372f2398a5$var$_styledComponents = $8b349b372f2398a5$var$_interopRequireWildcard($c906z$styledcomponents);
var $8b349b372f2398a5$var$_templateObject, $8b349b372f2398a5$var$_templateObject2, $8b349b372f2398a5$var$_templateObject3, $8b349b372f2398a5$var$_templateObject4;
function $8b349b372f2398a5$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($8b349b372f2398a5$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $8b349b372f2398a5$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $8b349b372f2398a5$var$_typeof(e) && "function" != typeof e) return {
        "default": e
    };
    var t = $8b349b372f2398a5$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $8b349b372f2398a5$var$_taggedTemplateLiteral(e, t) {
    return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
        raw: {
            value: Object.freeze(t)
        }
    }));
}
var $8b349b372f2398a5$var$TagSize = $8b349b372f2398a5$exports.TagSize = /*#__PURE__*/ function(TagSize) {
    TagSize["Large"] = "LARGE";
    TagSize["Default"] = "DEFAULT";
    return TagSize;
}({});
var $8b349b372f2398a5$var$largeStyles = (0, $8b349b372f2398a5$var$_styledComponents.css)($8b349b372f2398a5$var$_templateObject || ($8b349b372f2398a5$var$_templateObject = $8b349b372f2398a5$var$_taggedTemplateLiteral([
    "\n  ",
    "\n"
])), function(props) {
    return props.theme.typo.bodyS;
});
var $8b349b372f2398a5$var$colorStyles = $8b349b372f2398a5$exports.colorStyles = {
    blue: {
        color: "p400",
        bg: "p100"
    },
    orange: {
        color: "a400",
        bg: "a100"
    },
    green: {
        color: "b500",
        bg: "b100"
    },
    pink: {
        color: "c500",
        bg: "c100"
    },
    voilet: {
        color: "d400",
        bg: "d100"
    },
    gray: {
        color: "g500",
        bg: "g100"
    },
    red: {
        color: "e500",
        bg: "e100"
    }
};
var $8b349b372f2398a5$var$CounterWrapper = $8b349b372f2398a5$exports.CounterWrapper = $8b349b372f2398a5$var$_styledComponents["default"].div($8b349b372f2398a5$var$_templateObject2 || ($8b349b372f2398a5$var$_templateObject2 = $8b349b372f2398a5$var$_taggedTemplateLiteral([
    "\n  margin-left: 4px;\n  display: flex;\n  align-items: center;\n  border-radius: 50%;\n  ",
    "\n  background: ",
    ";\n  color: ",
    ";\n  width: 15px;\n  height: 15px;\n  justify-content: center;\n"
])), function(props) {
    return props.theme.typo.bodyXS;
}, function(props) {
    return props.theme.color.e500;
}, function(props) {
    return props.theme.color.white;
});
var $8b349b372f2398a5$var$Tag = $8b349b372f2398a5$exports.Tag = $8b349b372f2398a5$var$_styledComponents["default"].span($8b349b372f2398a5$var$_templateObject3 || ($8b349b372f2398a5$var$_templateObject3 = $8b349b372f2398a5$var$_taggedTemplateLiteral([
    "\n  ",
    "\n  display: inline-flex;\n  padding: 2px 8px;\n  ",
    "\n  flex-wrap: wrap;\n  align-items: center;\n  flex-direction: row;\n  color: ",
    ";\n  background-color: ",
    ";\n  ",
    "\n  border-radius: 20px;\n  ",
    "\n"
])), function(props) {
    return props.theme.typo.bodyXS;
}, function(props) {
    return props.onClick && "cursor: pointer;";
}, function(props) {
    return props.theme.color[$8b349b372f2398a5$var$colorStyles[props.color].color];
}, function(props) {
    return props.theme.color[$8b349b372f2398a5$var$colorStyles[props.color].bg];
}, function(props) {
    return props.size === $8b349b372f2398a5$var$TagSize.Large ? $8b349b372f2398a5$var$largeStyles : "";
}, function(props) {
    return "border: 1px solid ".concat(props.theme.color[$8b349b372f2398a5$var$colorStyles[props.color][props.noBorder ? "bg" : "color"]], ";");
});
var $8b349b372f2398a5$var$CloseIcon = $8b349b372f2398a5$exports.CloseIcon = (0, $8b349b372f2398a5$var$_styledComponents["default"])($c589462aca75b6d0$exports.CloseIcon)($8b349b372f2398a5$var$_templateObject4 || ($8b349b372f2398a5$var$_templateObject4 = $8b349b372f2398a5$var$_taggedTemplateLiteral([
    "\n  margin-left: 4px;\n  cursor: pointer;\n"
])));



var $7539930074911192$var$_excluded = [
    "onClick",
    "onClickCloseIcon",
    "color",
    "count",
    "children"
];
function $7539930074911192$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $7539930074911192$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $7539930074911192$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $7539930074911192$var$ownKeys(Object(t), !0).forEach(function(r) {
            $7539930074911192$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $7539930074911192$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $7539930074911192$var$_defineProperty(e, r, t) {
    return (r = $7539930074911192$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $7539930074911192$var$_toPropertyKey(t) {
    var i = $7539930074911192$var$_toPrimitive(t, "string");
    return "symbol" == $7539930074911192$var$_typeof(i) ? i : i + "";
}
function $7539930074911192$var$_toPrimitive(t, r) {
    if ("object" != $7539930074911192$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $7539930074911192$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $7539930074911192$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $7539930074911192$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var s = Object.getOwnPropertySymbols(e);
        for(r = 0; r < s.length; r++)o = s[r], t.includes(o) || ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $7539930074911192$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.includes(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var $7539930074911192$var$Tag = $7539930074911192$exports.Tag = function Tag(props) {
    var onClick = props.onClick, onClickCloseIcon = props.onClickCloseIcon, _props$color = props.color, color = _props$color === void 0 ? "blue" : _props$color, count = props.count, children = props.children, rest = $7539930074911192$var$_objectWithoutProperties(props, $7539930074911192$var$_excluded);
    return /*#__PURE__*/ (0, $c906z$reactjsxruntime.jsxs)($8b349b372f2398a5$exports.Tag, $7539930074911192$var$_objectSpread($7539930074911192$var$_objectSpread({}, rest), {}, {
        color: color,
        onClick: onClick,
        children: [
            children,
            count && /*#__PURE__*/ (0, $c906z$reactjsxruntime.jsx)($8b349b372f2398a5$exports.CounterWrapper, {
                children: count
            }),
            onClickCloseIcon && /*#__PURE__*/ (0, $c906z$reactjsxruntime.jsx)($8b349b372f2398a5$exports.CloseIcon, {
                colorCode: $8b349b372f2398a5$exports.colorStyles[color].color,
                onClick: onClickCloseIcon
            })
        ]
    }));
};





//# sourceMappingURL=index.js.map
